import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Testimonials.css';

const Testimonials = () => {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const quotes = t.testimonials.quotes;

  const nextSlide = () => {
    if (!quotes || quotes.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex + 1) % quotes.length);
  };

  const prevSlide = () => {
    if (!quotes || quotes.length === 0) return;
    setCurrentIndex((prevIndex) => (prevIndex - 1 + quotes.length) % quotes.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  // Auto-slide functionality (pause on hover)
  useEffect(() => {
    if (!quotes || quotes.length === 0) return;

    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % quotes.length);
      }, 3000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, quotes]);

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="testimonials-section" id="section-5">
        <div className="testimonials-wrap row">
          <div className="testimonials-title">
            <h4>{t.testimonials.title}</h4>
            <p>{t.testimonials.subtitle}</p>
          </div>

          <div
            className="testimonials-slider"
            style={{ direction: 'ltr', flexDirection: 'row' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button className="slider-arrow prev" onClick={prevSlide}>
              <i className="fa fa-chevron-left" />
            </button>

            <div className="testimonials-container">
              {quotes.map((quote, index) => (
                <div
                  key={index}
                  className={`testimonial-item ${index === currentIndex ? 'active' : ''}`}
                  style={{ display: index === currentIndex ? 'block' : 'none' }}
                >
                  <div className="testimonial-image">
                    <img src={quote.image} alt="Success quote" />
                  </div>
                  <div className="testimonial-content">
                    <p className="testimonial-quote">{quote.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="slider-arrow next" onClick={nextSlide}>
              <i className="fa fa-chevron-right" />
            </button>
          </div>

          <div className="slider-dots">
            {quotes.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
